import { RefinementCtx, ZodIssueCode, boolean, object, string, undefined, union } from "zod";

export const getFinanceCalculatorSchema = (
    minDepositAmountValue: number,
    maxDepositAmountValue: number,
    errorMessage: string
) =>
    object({
        preferredDepositAmount: string().transform((value: string, ctx: RefinementCtx): string => {
            if (!value) {
                ctx.addIssue({
                    code: ZodIssueCode.custom,
                    message: errorMessage,
                });
            }

            const parsedValue = parseInt(value.replaceAll(",", ""));

            if (isNaN(parsedValue)) {
                ctx.addIssue({
                    code: ZodIssueCode.custom,
                    message: errorMessage,
                });
            } else if (parsedValue < minDepositAmountValue || parsedValue > maxDepositAmountValue) {
                ctx.addIssue({
                    code: ZodIssueCode.custom,
                    message: errorMessage,
                });
            }

            return parsedValue.toString();
        }),
        isHP: boolean(),
        mileage: union([string(), undefined()]),
        selectedTerm: string(),
        selectedWarranty: string(),
        selectedPaintProtection: string(),
        selectedExteriorProtection: string(),
    });
